import {
  billingStreetAddress,
  billingCity,
  billingState,
  billingZipCode,
  billingPrivateMailbox,
  billingPoBoxNumber,
  billingUrbanizationName,
} from '@mgo/core/src/validations/address';

import {
  bufferedStartDate,
} from '@mgo/core/src/validations/coa';

import {
  firstName as preparerFirstName,
  lastName as preparerLastName,
  email as preparerEmail,
  phoneNumber as preparerPhoneNumber,
  phoneType as preparerPhoneType,
  recaptchaToken,
  recaptchaChallengeToken,
} from '@mgo/core/src/validations/person';

export default {
  billingStreetAddress,
  billingCity,
  billingState,
  billingZipCode,
  billingPrivateMailbox,
  billingPoBoxNumber,
  billingUrbanizationName,
  bufferedStartDate,
  preparerFirstName,
  preparerLastName,
  preparerEmail,
  preparerPhoneNumber,
  preparerPhoneType,
  recaptchaToken,
  recaptchaChallengeToken,
};
